module.exports = function getTranslationsForLang(translations, lang) {
  let newTranslations = {};

  for (let key in translations) {
    newTranslations[key] = translations[key][lang];
  }

  return newTranslations;
};
